class ClubFinder {
  constructor(root) {
    this.root = root;
    this.showcase = root.querySelector('[data-club-showcase]');
    this.rows = Array.from(root.querySelectorAll('[data-club-index]'));
    this.mediaQuery = window.matchMedia('(min-width: 990px)');

    const dataEl = root.querySelector('[data-club-finder-json]');
    try {
      this.clubs = dataEl ? JSON.parse(dataEl.textContent) : [];
    } catch (error) {
      this.clubs = [];
    }

    if (!this.showcase || !this.clubs.length) return;

    this.rows.forEach((row) => {
      row.addEventListener('click', (event) => this.handleRowClick(event, row));
    });
  }

  handleRowClick(event, row) {
    if (!this.mediaQuery.matches) return;

    const index = Number(row.dataset.clubIndex);
    const club = this.clubs[index];
    if (!club) return;

    event.preventDefault();
    this.activate(index, club, row);
  }

  activate(index, club, row) {
    this.rows.forEach((r) => {
      r.classList.toggle('club-finder__row--active', r === row);
      r.removeAttribute('aria-current');
    });
    row.setAttribute('aria-current', 'true');

    this.setText('[data-showcase-count]', club.count);
    this.setText('[data-showcase-name]', club.name);
    this.setText('[data-showcase-description]', club.description);
    this.setText('[data-showcase-cta-text]', club.ctaLabel);

    const ctaLink = this.showcase.querySelector('[data-showcase-cta]');
    if (ctaLink && club.url) ctaLink.href = club.url;

    const image = this.showcase.querySelector('[data-showcase-image]');
    if (image && club.image) {
      image.src = club.image;
      image.alt = club.name || '';
    }

    const slots = this.showcase.querySelectorAll('[data-showcase-product]');
    slots.forEach((slot, i) => {
      const product = club.products && club.products[i];
      if (!product) {
        slot.hidden = true;
        return;
      }
      slot.hidden = false;
      slot.href = product.url || '#';

      const productImage = slot.querySelector('[data-product-image]');
      if (productImage && product.image) {
        productImage.src = product.image;
        productImage.alt = product.name || '';
      }

      this.setText('[data-product-name]', product.name, slot);
      this.setText('[data-product-price]', product.price, slot);
    });
  }

  setText(selector, value, scope) {
    const el = (scope || this.showcase).querySelector(selector);
    if (el && value != null) el.textContent = value;
  }
}

document.querySelectorAll('[data-club-finder]').forEach((root) => new ClubFinder(root));
